module.exports = __webpack_public_path__ + "static/media/galerija_2014 (34).f2e3e9ae.jpg";